<template>
  <b-overlay
    variant="white"
    :show="loadingFiles"
    spinner-variant="primary"
    blur="0"
    opacity=".75"
    rounded="sm"
  >
  <div id="list-dnt">
    <div class="d-flex search-bar">
      <vs-input
        icon-after="true"
        class="mt-2 w-100"
        size="small"
        label-placeholder="icon-after"
        icon="mode_edit"
        placeholder="Buscar coincidencias"
        v-model="textSearch"
        v-on:keyup.enter="fetchDocuments()"
        data-cy="search"
      />
      <vs-button
        v-if="searchParam"
        radius
        class="ml-3"
        color="primary"
        type="border"
        icon="highlight_off"
        size="small"
        @click="clearSearch()"
      />
    </div>
    <SimpleFilters :filtersFiles="filters" />
    <FilesFilters
      :value="filters"
      :onChange="onChangeFilters"
      :clear="clearFilters"
    />
    <FilesHeader :on-pending-files="onPendingFiles" />
    <div class="force-render" :key="forceRender">
      <FileRow
        :key="file.febosId"
        v-for="file in filteredFiles"
        :file="file"
        :on-pending-files="onPendingFiles"
        :on-general-files="onGeneralFiles"
        :on-support-files="onSupportFiles"
        :on-processed-files="onProcessedFiles"
        :on-entered-files="onEnteredFiles"
        :on-pre-salida="onPreSalida"
        :on-incomplete-files="onIncompleteFiles"
        :select-file="selectFile"
        data-cy="file"
      />
    </div>
    <PopUpBinnacleFile :file="selectedFile"/>
    <PopUpTimelineFile :file="selectedFile"/>
    <PopUpReferencesFile :file="selectedFile"/>
    <PopUpDetailFile :file="selectedFile" />
    <PopUpGeneralDetailFile @reload="reload" :file="selectedFile" />
    <PopUpFlowFile :file="selectedFile" />
    <PopUpCancelFile :canceledFile="selectedFile" />
    <PopUpProcessFile :processedFile="selectedFile" />
    <KanbanTaskFile :file="selectedFile" />
    <PopUpControlReceivedFile :control-file="selectedFile" />
    <PopUpArchiveFile :processedFile="selectedFile" />
    <PopUpRecoverFile :file="selectedFile" />
    <PopUpReturnFile :file="selectedFile" />
    <PopUpAsignFile @reload="reload" :file="selectedFile" />
    <PopUpAnswerFile :file="selectedFile" />
    <PopUpParticipantsFile :file="selectedFile" />
    <PopUpCommentsFile :file="selectedFile" />
    <PopUpTicketFile :file="selectedFile" />
    <PopUpSendFile :file="selectedFile" v-if="selectedFile" />
    <PopUpNotifyFile :file="selectedFile" />
    <PopUpActivityTimelineFile :file="selectedFile" />
    <PopUpAnswerFileAguasAndinas :file="selectedFile" />
    <PopUpViewResponseAguasAndinas :file="selectedFile"/>
    <PopUpSendToDocDigital @reload="reload" :file="selectedFile" v-if="selectedFile" />
    <PopUpUpdatePrivacity @reload="reload" :file="selectedFile"  />
    <vs-row>
      <vs-col vs-lg="3">
        <div class="mt-5">
          Mostrando
          <select v-model="rowspp" @change="fetchDocuments()">
            <option value="10" selected="selected">10</option>
            <option value="15">15</option>
            <option value="30">30</option>
            <option value="50">50</option>
          </select> registros por página.
        </div>
      </vs-col>
      <vs-col vs-lg="9">
        <FilesPagination
          :show="files.length"
          v-model="page"
        />
      </vs-col>
    </vs-row>
  </div>
  </b-overlay>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

import PopUpCancelFile from '@/febos/chile/dnt/vistas/modals/PopUpCancelFile';
import PopUpDetailFile from '@/febos/chile/dnt/vistas/modals/PopUpDetailFile';
import PopUpReferencesFile from '@/febos/chile/dnt/vistas/modals/PopUpReferencesFile';
import PopUpGeneralDetailFile from '@/febos/chile/dnt/vistas/modals/PopUpGeneralDetailFile';
import PopUpFlowFile from '@/febos/chile/dnt/vistas/modals/PopUpFlowFile';
import PopUpProcessFile from '@/febos/chile/dnt/vistas/modals/PopUpProcessFile';
import KanbanTaskFile from '@/febos/chile/dnt/vistas/modals/KanbanTaskFile';
import PopUpControlReceivedFile from '@/febos/chile/dnt/vistas/modals/PopUpControlReceivedFile';
import PopUpArchiveFile from '@/febos/chile/dnt/vistas/modals/PopUpArchiveFile';
import PopUpRecoverFile from '@/febos/chile/dnt/vistas/modals/PopUpRecoverFile';
import PopUpReturnFile from '@/febos/chile/dnt/vistas/modals/PopUpReturnFile';
import PopUpAsignFile from '@/febos/chile/dnt/vistas/modals/PopUpAsignFile';
import PopUpAnswerFile from '@/febos/chile/dnt/vistas/modals/PopUpAnswerFile';
import PopUpAnswerFileAguasAndinas from '@/febos/chile/dnt/vistas/modals/PopUpAnswerFileAguasAndinas';
import PopUpTicketFile from '@/febos/chile/dnt/vistas/modals/PopUpTicketFile';
import PopUpSendFile from '@/febos/chile/dnt/vistas/modals/PopUpSendFile';
import PopUpNotifyFile from '@/febos/chile/dnt/vistas/modals/PopUpNotifyFile';
import PopUpActivityTimelineFile from '@/febos/chile/dnt/vistas/modals/PopUpActivityTimelineFile';
import PopUpParticipantsFile from '@/febos/chile/dnt/vistas/modals/PopUpParticipantsFile';
import PopUpCommentsFile from '@/febos/chile/dnt/vistas/modals/PopUpCommentsFile';
import PopUpViewResponseAguasAndinas from '@/febos/chile/dnt/vistas/modals/PopUpViewResponseAguasAndinas';
import PopUpSendToDocDigital from '@/febos/chile/dnt/vistas/modals/PopUpSendToDocDigital';
import PopUpUpdatePrivacity from '@/febos/chile/dnt/vistas/modals/PopUpUpdatePrivacity';
import FilesHeader from '@/febos/chile/dnt/components/files/FilesHeader';
import FileRow from '@/febos/chile/dnt/components/files/FileRow';
import PopUpTimelineFile from '@/febos/chile/dnt/vistas/modals/PopUpTimelineFile';
import PopUpBinnacleFile from '@/febos/chile/dnt/vistas/modals/PopUpBinnacleFile';
import FilesFilters from '@/febos/chile/dnt/components/files/FilesFilters';
import FilesPagination from '@/febos/chile/dnt/components/files/FilesPagination';
import { mergeFilters } from '@/febos/chile/dnt/utils/fitlers';
import { removeSearchParams, updateSearchParams } from '@/febos/global/utils/router';
import SimpleFilters from '@/febos/chile/dnt/vistas/SimpleFilters';

export default {
  name: 'Files',
  components: {
    PopUpUpdatePrivacity,
    SimpleFilters,
    FilesPagination,
    FilesFilters,
    PopUpBinnacleFile,
    PopUpAnswerFile,
    PopUpReferencesFile,
    PopUpTimelineFile,
    FileRow,
    FilesHeader,
    PopUpDetailFile,
    PopUpGeneralDetailFile,
    PopUpFlowFile,
    PopUpCancelFile,
    PopUpAsignFile,
    PopUpProcessFile,
    KanbanTaskFile,
    PopUpControlReceivedFile,
    PopUpArchiveFile,
    PopUpRecoverFile,
    PopUpReturnFile,
    PopUpParticipantsFile,
    PopUpCommentsFile,
    PopUpTicketFile,
    PopUpSendFile,
    PopUpNotifyFile,
    PopUpActivityTimelineFile,
    PopUpAnswerFileAguasAndinas,
    PopUpViewResponseAguasAndinas,
    PopUpSendToDocDigital
  },
  data() {
    const { view } = this.$route.params;

    return {
      loadingFiles: false,
      onPendingFiles: view === 'pendientes',
      onGeneralFiles: view === 'general',
      onSupportFiles: view === 'generalSoporte',
      onProcessedFiles: view === 'tramitados',
      onEnteredFiles: view === 'ingresados',
      onPreSalida: view === 'presalida',
      onIncompleteFiles: view === 'completitudDatos',
      isShared: view === 'compartido',
      fromCS: view === 'docDigital',
      selectedFile: {},
      filters: '',
      textSearch: '',
      rowspp: Number.parseInt(this.$route.query.paginate || 10, 10),
      searchParam: false,
      page: Number.parseInt(this.$route.query.page || 1, 10),
      forceRender: Date.now() // TODO: the files watch is triggered but the component not re-render.
    };
  },
  watch: {
    loading(value) {
      this.loader(value);
    },
    loadingBinnacle(value) {
      this.loader(value);
    },
    companyLoading(value) {
      this.loader(value);
    },
    textSearch(oldValue, newVaue) {
      if (oldValue !== newVaue) {
        this.searchParam = false;
      }
    },
    files() {
      this.forceRender = Date.now(); // TODO: remove this.
    },
    async page(page) {
      updateSearchParams({ page });
      await this.fetchDocuments();
    },
    successAction() {
      this.$bvToast.toast(
        'Acción realizada exitosamente',
        {
          title: '¡Genial!',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          noAutoHide: true
        }
      );
    },
    error(error) {
      if (error !== '') {
        this.$bvToast.toast(
          `${error}`,
          {
            title: '¡Oops!',
            variant: 'danger',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
        this.clearErrorMessage();
      }
    }
  },
  computed: {
    ...mapGetters('Dnts', [
      'loading',
      'loadingBinnacle',
      'error',
      'successAction',
      'files'
    ]),
    ...mapGetters('Empresas', ['company']),
    ...mapGetters('Empresas', { companyLoading: 'loading' }),
    isConvention() {
      return this.company.iut === '60100003-2';
    },
    isAguasAndinas() {
      return this.company.iut === '61808000-5';
    },
    filteredFiles() {
      return this.files;
    }
  },
  methods: {
    ...mapActions('Dnts', [
      'listDocuments',
      'clearErrorMessage',
      'selectFileState'
    ]),
    ...mapActions('Modals', [
      'closeModal'
    ]),
    ...mapActions('List', [
      'fetchAllDocuments'
    ]),
    loader(value) {
      if (this.loadingFiles) return;
      if (value) {
        this.$vs.loading({
          container: '#app',
          scale: 0.6
        });
      } else {
        this.$vs.loading.close('#app > .con-vs-loading');
      }
    },
    async reload() {
      await this.fetchDocuments();
    },
    async clearSearch() {
      this.searchParam = false;
      this.textSearch = '';
      await this.fetchDocuments();
    },
    async searchCoincidences() {
      this.searchParam = true;
      await this.fetchDocuments();
    },
    selectFile(file) {
      this.selectedFile = file;
      this.selectFileState(file.febosId);
    },
    async onChangeFilters(filters, onMounted) {
      this.filters = filters;
      if (!onMounted) {
        if (this.page !== 1) {
          this.page = 1;
          // using else because this method has two responsibilities
        } else {
          // force fetch (if we change the page from 1 to 1 the watcher not run)
          await this.fetchDocuments();
        }
      }
    },
    clearFilters() {
      removeSearchParams(['filters']);
      // TODO: try to change to default filter state for current view.
      updateSearchParams({ page: 1 });
      this.$router.go();
    },
    getFilters() {
      // Esta condición es para ver referencias en base a febosId
      if (this.$route.query?.filters) {
        if (this.$route.query.filters
          .includes('febosId') && !this.onPendingFiles) {
          return this.$route.query.filters;
        }
      }
      return mergeFilters(this.filters, this.$route.query.filters);
    },
    async fetchDocuments() {
      this.loadingFiles = true;
      const filtroContent = this.textSearch !== '' ? `|content$${ this.textSearch}` : '';
      const query = {
        params: {
          tipo: 'EXP',
          campos: '*',
          pagina: this.page,
          orden: '-fechaCreacion',
          elementosPorPagina: this.rowspp,
          filtros: this.getFilters() + filtroContent
        }
      };
      await this.listDocuments(query);
      this.loadingFiles = false;
    }
  },
  created() {
    this.closeModal();
    this.selectFileState('');
  },
  mounted() {
    this.fetchAllDocuments();
    this.fetchDocuments();
  }
};
</script>
<style>
.rowspp{

}
</style>
